import { ENTITY_MAP } from '../../app/app.config.entity-map';
import { BaseObject } from '../business-objects/base-object/base-object.model';

export const getEntityType = (entityInstance: BaseObject): string => {

    for (const name in ENTITY_MAP) {
        if (entityInstance instanceof ENTITY_MAP[name]) {
            return name;
        }
    }

    throw Error('instance name not found');
};



// WEBPACK FOOTER //
// ./src/core/util/get-entity-type.ts